const animationHidingTime = 1000;

export const removeMainAnimation = () => {
  setTimeout(() => {
    const animationId = document.getElementById("mainLoadingAnimation");
    animationId.style.display = "none";
  }, [animationHidingTime]);
};
